module.exports = __webpack_public_path__ + "img/Group 681.d8f7e9fc.png";